
import { computed, defineComponent, onMounted, onUnmounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useGlobalStore } from "@/stores/global";
import BaseillustMaster from "@/masters/baseillust-master";
import Select from "@/javascripts/image/select";
import EnterButton from "@/components/EnterButton.vue";
import Header from "@/components/Header.vue";
import Alert from "@/components/Alert.vue";
import Upload from "@/components/Upload.vue";

/**
 * TODO
 *  ・lazyload
 *    ・現状、imgの画像の指定をdata-srcからsrcに変更してしまっている
 */
export default defineComponent({
  name: "Select",
  components: {
    EnterButton,
    Header,
    Alert,
    Upload,
  },
  setup() {
    const router = useRouter();
    const toTrim = () => router.push({ name: "trim" });
    const toEdit = () => router.push({ name: "edit" });

    const select = new Select();

    const { imageEditor } = useGlobalStore();
    const isShowAlertLoad: boolean = imageEditor.hasSelectedImage();

    const baseillusts = BaseillustMaster.records;
    const defaultBaseillustCategoryId: number = 1;

    /**
     * 仮選択画像
     */
    const preSelectedImage = ref<BaseillustMaster>(null);

    const uploadedImage = ref<String>(null);

    const canClickDecisionBtn = ref<Boolean>(false);

    onMounted(() => {
      setupView();
    });

    onUnmounted(() => {});

    /**
     * 画像が選択されているか
     */
    const isImagePreselected = computed(
      () =>
        function (image: BaseillustMaster): Boolean {
          if (!preSelectedImage.value) {
            return false;
          }
          return image.id == preSelectedImage.value.id;
        }
    );

    /**
     * 画面表示の初期処理
     */
    function setupView() {
      select.toggleBaseillustCategory(defaultBaseillustCategoryId);

      if (isShowAlertLoad) {
        select.showAlertLoad();
      }
    }

    /**
     * 決定ボタン押下時の処理
     */
    function onClickDecisionBtn() {
      imageEditor.selectImage(preSelectedImage.value);
      select.barragePreventAll();
      toTrim();
    }

    /**
     * 保存データ初期化ボタン押下時の処理
     */
    function onClickRestart() {
      imageEditor.resetImage();
      select.restartOnAlertLoad();
    }

    /**
     * 保存データ編集続行ボタン押下時の処理
     */
    function onClickContinue() {
      select.continueOnAlertLoad();
      toEdit();
    }

    /**
     * ベース画像押下時の処理
     */
    function onClickBaseillust(image: BaseillustMaster) {
      preselectImage(image);
      removeUploadedImage();
      makeDecisionBtnClickable();
    }

    /**
     * 画像の仮選択
     */
    function preselectImage(image: BaseillustMaster) {
      preSelectedImage.value = image;
    }

    /**
     * 背景素材種別の切り替え
     */
    function toggleBaseillustType(type: Number) {
      select.toggleBaseillustType(type);
    }

    /**
     * 画像アップロード
     */
    function uploadImage(newImage: String) {
      uploadedImage.value = newImage;
      const image: BaseillustMaster = new BaseillustMaster({
        id: BaseillustMaster.UploadedId,
        fileName: "",
        src: newImage,
      });
      preselectImage(image);
      makeDecisionBtnClickable();
    }

    /**
     * アップロード画像の削除
     */
    function removeUploadedImage() {
      uploadedImage.value = null;
      makeDecisionBtnUnclickable();
    }

    /**
     * 決定ボタンをクリック可に変更
     */
    function makeDecisionBtnClickable() {
      canClickDecisionBtn.value = true;
    }

    /**
     * 決定ボタンをクリック不可に変更
     */
    function makeDecisionBtnUnclickable() {
      canClickDecisionBtn.value = false;
    }

    return {
      toTrim,
      baseillusts,
      onClickBaseillust,
      onClickDecisionBtn,
      onClickRestart,
      onClickContinue,
      isImagePreselected,
      toggleBaseillustType,
      uploadImage,
      removeUploadedImage,
      uploadedImage,
      canClickDecisionBtn,
    };
  },
});
